/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRarIcon20Regular = forwardRef('GovKoRarIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.25.5A4.25 4.25 0 0 0 9.5 4.75c.288 0 .5-.062.5-.375A4.375 4.375 0 0 0 5.626 0c-.312 0-.375.212-.375.5Z" }),
        React.createElement("path", { d: "M11.803 8.003a1.803 1.803 0 1 1-3.605 0 1.803 1.803 0 0 1 3.605 0Z" }),
        React.createElement("path", { d: "M11.803 16.997a1.803 1.803 0 1 1-3.605 0 1.803 1.803 0 0 1 3.605 0Z" }),
        React.createElement("path", { d: "M4.842 9.805a1.803 1.803 0 1 0 0-3.605 1.803 1.803 0 0 0 0 3.605Z" }),
        React.createElement("path", { d: "M16.962 8.003a1.803 1.803 0 1 1-3.606 0 1.803 1.803 0 0 1 3.606 0Z" }),
        React.createElement("path", { d: "M7.42 14.305a1.803 1.803 0 1 0 0-3.605 1.803 1.803 0 0 0 0 3.605Z" }),
        React.createElement("path", { d: "M14.383 12.503a1.803 1.803 0 1 1-3.606 0 1.803 1.803 0 0 1 3.606 0Z" })));
});
